import {
  CustomLabel,
  FlexContainer,
  TableContainer,
  ITableHeaders,
  ToastService,
  CollapsiblePanel,
  Loader,
} from "@mindmemobile/mm-shared-global";
import React, { useState } from "react";
import { BeneficiaryModel } from "../../../shared/models";
import { VariantWrapper } from "../../../shared/styles";
import { TableGrid } from "../../../shared/components";
import DeleteIcon from "../../../../../../images/products/trash-blue.svg";
import RenameIcon from "../../../../../../images/common/rename-icon-blue.svg";

type IProps = {
  beneficiaries: BeneficiaryModel[];
  isLoading: boolean;
};

const Beneficiaries: React.FC<IProps> = ({ beneficiaries, isLoading }) => {
  const [selectedBeneficiary, setSelectedBeneficiary] =
    useState<BeneficiaryModel | null>(null);

  const onClickRename = (beneficiary: BeneficiaryModel) => {
    setSelectedBeneficiary(beneficiary);
    console.log(selectedBeneficiary);
  };

  const onClickDelete = (beneficiary: BeneficiaryModel) => {
    const updatedBeneficiaries = beneficiaries.filter(
      (b) => b.id !== beneficiary.id
    );
    console.log(updatedBeneficiaries);
  };

  const columns = (): ITableHeaders<BeneficiaryModel>[] => [
    {
      dataKey: "name",
      title: "Beneficiary Name",
      className: "table-col-40",
      cellClassName: "table-col-40",
      onCellRender: (data: BeneficiaryModel) => {
        return <CustomLabel>{data.name}</CustomLabel>;
      },
    },
    {
      dataKey: "name",
      title: "Used In Items",
      cellColor: "#556bb8",
      className: "table-col-20 text-center",
      cellClassName: "table-col-20 text-center",
      onCellRender: (data: BeneficiaryModel) => {
        return <CustomLabel>{"0"}</CustomLabel>;
      },
    },
    {
      dataKey: "name",
      title: "Actions",
      className: "table-col-20 text-center",
      cellClassName: "table-col-20 text-center",
      onCellClick: (e) => {
        e.stopPropagation();
      },
      onCellRender: (data: BeneficiaryModel) => {
        return (
          <FlexContainer
            alignItems="center"
            justifyContent="center"
            spacing={10}
          >
            <img
              src={RenameIcon}
              alt="rename"
              style={{ cursor: "not-allowed" }}
              onClick={(e) => {
                e.stopPropagation();
                onClickRename(data);
              }}
              className="img-15 clickable"
            />
            <img
              alt="del"
              src={DeleteIcon}
              style={{ cursor: "not-allowed" }}
              onClick={(e) => {
                e.stopPropagation();
                onClickDelete(data);
              }}
              className="img-15 clickable"
            />
          </FlexContainer>
        );
      },
    },
  ];

  if (isLoading) {
    return <>{new Loader(true).loaderComponent}</>;
  }
  if (beneficiaries.length < 1) {
    return null;
  }
  return ( 
    <VariantWrapper className="beneficiary-block">
      <CollapsiblePanel
        title="Beneficiaries"
        className="payment-detail-header"
        collapsibleClassName="full-width"
        isOpened={false}
      >
        <TableContainer className="ps-left-margin beneficiaries-table">
          <TableGrid
            totalItemCount={beneficiaries.length}
            cellSpacing={20}
            data={beneficiaries || []}
            headers={columns()}
            className="recent-customer-table table item-variant-table variant-table-chckbx"
          />
        </TableContainer>
      </CollapsiblePanel>
    </VariantWrapper>
  );
};

export default Beneficiaries;
